import { jsx as _jsx } from "react/jsx-runtime";
import { AnnotationOutlinePlus, Eye, FullScreenEnter } from "@air/next-icons";
import { UploadStatus } from "@air/redux-uploader";
export const VERSION_THUMBNAIL_HEIGHT = 72;
export const VERSION_THUMBNAIL_WIDTH = 112;
export const IMGX_OPTIONS = {
    fit: "clip",
    auto: "compress",
    cs: "origin"
};
export const INVALID_VERSION_UPLOAD_STATUS = [
    UploadStatus.aborted,
    UploadStatus.failed,
    UploadStatus.rejected
];
export const DEFAULT_AMOUNT_OF_CUSTOM_FIELDS_TO_SHOW = 3;
export var AssetModalViewMode;
(function(AssetModalViewMode) {
    AssetModalViewMode["Fullscreen"] = "fullscreen";
    AssetModalViewMode["View"] = "view-mode";
    AssetModalViewMode["Comment"] = "comment-mode";
})(AssetModalViewMode || (AssetModalViewMode = {}));
export const SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS = [
    {
        label: /*#__PURE__*/ _jsx(FullScreenEnter, {
            className: "size-4"
        }),
        value: "fullscreen",
        id: "fullscreen",
        tooltip: "Presentation mode"
    },
    {
        label: /*#__PURE__*/ _jsx(Eye, {
            className: "size-4"
        }),
        value: "view-mode",
        id: "view-mode",
        tooltip: "View mode"
    },
    {
        label: /*#__PURE__*/ _jsx(AnnotationOutlinePlus, {
            className: "size-4"
        }),
        value: "comment-mode",
        id: "comment-mode",
        tooltip: "Comment mode"
    }
];
export const SEARCH_WIDTH = 216;
